import { useIntl } from 'react-intl';
import { useCallback } from 'react';

import { useSnackbar } from '@ocx-app/lib/snackbar/snackbar';

import { useConfiguration } from '@ocx/data-configuration';
import { PurchaseIneligibilityReason } from '@ocx/data-offers';

import { getIneligibilityMessageDescriptor } from './ineligibility.messages';

export const useShowExplanationSnackbarForIneligibleOffer = () => {
  const intl = useIntl();
  const snackbar = useSnackbar();
  const pointsStrategy = useConfiguration('loyaltyProgram.pointsStrategy');

  return useCallback(
    (reason: PurchaseIneligibilityReason) => {
      snackbar.open(intl.formatMessage(getIneligibilityMessageDescriptor(reason, pointsStrategy)));
    },
    [intl, pointsStrategy, snackbar],
  );
};
